import { render, staticRenderFns } from "./ViewScopingPicot.vue?vue&type=template&id=5fd5e45e&scoped=true"
import script from "./ViewScopingPicot.vue?vue&type=script&lang=js"
export * from "./ViewScopingPicot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd5e45e",
  null
  
)

export default component.exports